import * as React from "react";
import { IBillOfLadingPaymentResponse } from "Core/Api/Payment/Api";
import { withRouter, RouteComponentProps, NavLink } from "react-router-dom";
import Form, { FormComponentProps } from "antd/lib/form";
import { Row, Col, Button } from "antd";
import receiptErrorPng from '../../../assets/images/Receipt.png'
import Utility from "Core/Utility";
import { CenterAlignRow } from "components/Styled/Layout.Styled";

export interface Props extends FormComponentProps, RouteComponentProps {
    children?: React.ReactNode
}

export interface State {
}

class GeneralPaymentErrorWithoutRouterAndForm extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)

        this.state = {
        }
    }

    componentDidMount() {
        let state: IBillOfLadingPaymentResponse = {};
    }

    generateErrorMessage(receipt: IBillOfLadingPaymentResponse): React.ReactNode {

        if (receipt) {
            switch (receipt.errorCode) {
                case "NORMAL_DECLINE":
                    return (<>
                        <p>The transaction has been declined</p>
                    </>)
                case "INVALID_CVV":
                    return (<>
                        <p>The CVV was not correct</p>
                    </>)
                    break;
                case "CREDITCARD_NOT_REGISTERED":
                    return (<>
                        <p>This credit card is not registered on this platform</p>
                        <p>please ensure the card is registered and that the card information entered is accurate</p>
                    </>)
                    break;
                case "INVALID_BILL_ITEMS":
                case "NO_BOL_CHARGES":
                case "INCORRECT_PAYMENT_TOTAL":
                case "BILL_ALREADY_PAID":
                case "APM_NO_RECIEPT":
                    return (<>
                        <p>There was an error while charging the bill of lading</p>
                        <p>For your safety, we advice that you do not attempt to make another payment until you have spoken to a Customer Care representative</p>
                        <p>Please <NavLink to='https://kingstonwharves.com/contacts/'>contact</NavLink> administrator at {Utility.ContactTel()}.</p>
                    </>)
                    break;

                default:
                    return (<>
                        <p>There was an issue with the card details or while making a payment. Please contact your financial institution for further assistance.</p>
                    </>)
                    break;
            }
        } else {
            return (<>
                <p>There was an error begin payment processing. Please check the information you entered and try again.</p>
                <p>If the error presists</p>
                <p>Please <NavLink to='https://kingstonwharves.com/contacts/'>contact</NavLink> administrator at {Utility.ContactTel()}.</p>
            </>)
        }
    }

    render() {
        const receipt = (this.props.location?.state) as IBillOfLadingPaymentResponse;

        var errorDisplay;
        errorDisplay =
            <>
                <Row style={{ border: "solid lightgrey 2px", borderRadius: "15px", padding: "15px 20px", marginTop: "5px" }}>
                    <Row>
                        <Col><b>
                            <img src={receiptErrorPng} />
                            {this.generateErrorMessage(receipt)}
                            {receipt?.paymentRefenceNumber && <p>Reference: {receipt?.paymentRefenceNumber}</p>}

                        </b>
                        </Col>
                    </Row>
                    <CenterAlignRow >
                        <Col>
                            <Button><NavLink to="/home">Back to Home</NavLink></Button>
                        </Col>
                    </CenterAlignRow>
                    <CenterAlignRow style={{ paddingTop: "5px" }}>
                        <Col>
                            <Button><NavLink to="/checkout">Back to Checkout</NavLink></Button>
                        </Col>
                    </CenterAlignRow>
                </Row>
            </>

        return (
            <>
                {errorDisplay}
            </>
        )
    }
}

const GeneralPaymentErrorWithoutRouter = Form.create<Props>({
    name: 'GeneralPaymentError',
})(GeneralPaymentErrorWithoutRouterAndForm);

const GeneralPaymentError = withRouter(GeneralPaymentErrorWithoutRouter);

export default GeneralPaymentError;